<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm02"></a><a id="page_ii">Don’t miss any books in this thrilling new series:</a></p><a id="page_ii">
<p class="bstextcentert"><strong><em>FEARLESS</em><sup>™</sup></strong></p>
<p class="textcenter"><em>#1 Fearless<br/>#2 Sam<br/>#3 Run<br/>#4 Twisted<br/>#5 Kiss<br/>#6 Payback<br/>#7 Rebel<br/>#8 Heat</em></p>
<p class="bstextcenter">Available from POCKET PULSE</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?199736af